import Attribute from '../Interfaces/Attribute';
import Pluginz from '../Interfaces/Pluginz';
import Plugins from './Plugins';

export default class Passfield extends Plugins implements Pluginz {
    public objectName: string = 'Passfield';
    public pluginName: string = 'passfield';
    public isjQuery: boolean = false;
    public selector: string;
    public jsConfig: string = 'default';
    public replacements: any = [];
    public dataAttributes: Array<Attribute> = [];

    constructor(selector = '') {
        super();
        this.selector = selector;
    }

    render(compSettings) {
        const $fieldset = $('<fieldset />').addClass(compSettings.ui.fieldsetClass + ' ' + this.objectName + '-fieldset' + this.getJsClass(this.isjQuery));
        const $doc = compSettings.addDocumentation('https://www.phpformbuilder.pro/documentation/javascript-plugins.php#passfield-example');
        const $legend = $('<legend />').html('Passfield').append($doc).addClass(compSettings.ui.legendClass);
        $fieldset.append($legend);


        // jsConfig
        const selectData = {
            data: {
                plugin: 'Passfield',
                prop: 'jsConfig'
            },
            name: 'passfield-jsconfig-data',
            label: 'Config.',
            helper: '<a href="https://www.phpformbuilder.pro/documentation/javascript-plugins.php#passfield-example" target="_blank">Documentation <i class="icon-outlink ms-1"></i></a>',
            value: this.jsConfig
        }
        const selectOptions: Array<string> = ['default', 'min-5', 'min-6', 'min-8', 'lower-upper-min-5', 'lower-upper-min-6', 'lower-upper-min-8', 'lower-upper-number-min-5', 'lower-upper-number-min-6', 'lower-upper-number-min-8', 'lower-upper-number-symbol-min-5', 'lower-upper-number-symbol-min-6', 'lower-upper-number-symbol-min-8'];
        const $selectjsConfig = compSettings.addSelect(selectData, selectOptions);

        $fieldset.append($selectjsConfig);

        return $fieldset;
    }
}
